export default __webpack_public_path__ + "static/media/astorpay.59bea7ea.svg";